import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogProps,
} from "@mui/material";

type BaseModalProps = {
  open: boolean;
  onClose: () => void;
  title?: React.ReactNode;
  children: React.ReactNode;
  actions?: React.ReactNode;
  onEntered?: () => void;
  maxWidth?: DialogProps["maxWidth"];
};

export const BaseModal = ({
  open,
  onClose,
  title,
  children,
  actions,
  onEntered,
  maxWidth = "sm",
}: BaseModalProps) => {
  return (
    <Dialog
      open={open}
      TransitionProps={{
        onEntered: onEntered,
      }}
      onClose={(_, reason) => {
        // 外側クリック・ESCキーでは閉じさせない
        if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
          onClose();
        }
      }}
      maxWidth={maxWidth}
      fullWidth
    >
      {title && <DialogTitle sx={{ p: 3 }}>{title}</DialogTitle>}
      <DialogContent sx={{ p: 3 }} dividers>
        {children}
      </DialogContent>
      {actions && <DialogActions sx={{ p: 2 }}>{actions}</DialogActions>}
    </Dialog>
  );
};
